<script setup lang="ts">

import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { ModalDefault } from '@shared/ui/modals'
import { LinkTextPrimary } from '@shared/ui/links'
import { AppIcon } from '@shared/ui/icons'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import DisciplineScheduleOutside from '../DisciplineScheduleOutside.vue'
import DisciplineScheduleGrid from '../DisciplineScheduleGrid.vue'
import { useModalDisciplineScheduleSlots } from '../../model/modal-discipline-schedule-slots.hook'

defineOptions({
  name: 'ModalDisciplineScheduleSlots',
})

const {
  refIsChange,
  refTitle,
  refHasBack,
  refChooseText,
  refErrorText,
  refHasError,
  refTimezoneText,
  refScheduleUrl,
  refIsLoading,
  refIsDisabled,
  close,
  back,
  confirm,
} = useModalDisciplineScheduleSlots()
</script>

<template>
  <ModalDefault
    show
    :title="refTitle"
    :loading="refIsLoading"
    class-name="modal-discipline-schedule-wide"
    is-close-button
    :is-back-button="refHasBack"
    @click:overlay="close"
    @click:close="close"
    @click:back="back"
  >
    <div class="modal-discipline-schedule-slots">
      <div class="modal-discipline-schedule-slots__info">
        <div class="modal-discipline-schedule-slots__texts">
          <div class="modal-discipline-schedule-slots__detail">
            <AppText name="body1">
              {{ refChooseText }}
            </AppText>
            <LinkTextPrimary
              v-if="refIsChange && refScheduleUrl"
              :href="refScheduleUrl"
              target="_blank"
              class="modal-discipline-schedule-slots__calendar"
            >
              Tutor calendar
              <AppIcon
                :icon="faArrowUpRight"
                size="small"
              />
            </LinkTextPrimary>
          </div>
          <AppText
            name="body2"
            color="slate-500"
          >
            {{ refTimezoneText }}
          </AppText>
          <AppText
            v-if="refHasError"
            name="body1"
            color="red-500"
          >
            {{ refErrorText }}
          </AppText>
        </div>
        <DisciplineScheduleOutside v-if="refIsChange" />
      </div>
      <DisciplineScheduleGrid />
    </div>
    <template #controls>
      <BtnPrimary
        text="Continue"
        color="emerald"
        :disabled="refIsDisabled"
        @click="confirm"
      />
      <BtnSecondary
        text="Cancel"
        color="black"
        @click="close"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalDisciplineSchedule.scss" />
<style scoped lang="scss" src="./ModalDisciplineScheduleSlots.scss" />
